import { firstOklahoma } from "@assets/images";
import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 109;
const HEIGHT = 51;

export const FirstOklahomaLogo = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <img
      src={firstOklahoma}
      alt=""
      className={className}
      style={{ ...size, objectFit: "contain", ...style }}
    />
  );
};
